import React, { useState, useEffect, useContext } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { MenuAlt1Icon, XIcon } from '@heroicons/react/outline'
import Link from 'gatsby-link'
import SbEditable from 'storyblok-react'
import LogoDefault from "static/logo_primary.svg"
import LogoWhite from "static/logo_all_white.svg"
import resolveLink from 'src/utils/resolveLink'
import Button from 'src/components/Button'
import Hexagons from "src/images/hexagon-white-bottom.svg"
import { PageContext } from 'src/utils/context'

const Navigation = ({ settings, lang }) => {

  const { hasHero, currentPage } = useContext(PageContext)

  const [scrollLock, setScrollLock] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  // Change the style of the navbar on scroll
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
  }

  // Bundle up three different utilities into one useEffect
  useEffect(() => {
    // Check for scroll
    window.addEventListener("scroll", handleScroll)
    // Disable body scrolling
    if ( scrollLock ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible"
    }
    // https://github.com/tailwindlabs/tailwindcss/discussions/1610#discussioncomment-352836
    // gets screen size - to fix mobile viewport height problem
    if (typeof window !== 'undefined') {

      function handleResize() {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      }

      window.addEventListener("resize", handleResize);

      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [scrolled, scrollLock])

  const Logo = !hasHero || scrolled ? LogoDefault : LogoWhite

  return (
    <SbEditable content={settings} key={settings._uid}>
      <div className={`w-full fixed top-0 z-[9999999999] ${!hasHero ? "bg-white" : scrolled ? "bg-white" : "bg-transparent"}`}>
      <header className="mx-auto px-6 lg:px-12">
              <nav className={`flex w-full items-center transition-all duration-300 ${scrolled ? 'lg:py-4 py-3' : 'lg:py-8 pt-4'}`}>
                <div className="flex justify-between items-center flex-1">
                  <Link to="/">
                    <span className="sr-only">Generation Media</span>
                    <img
                      className="w-40"
                      src={Logo}
                      alt="Generation Media Logo"
                    />
                  </Link>
                  {/* Nav Links */}
                  <div className={`ml-auto flex gap-6 menu-text ${!hasHero ? "text-midnight" : scrolled ? "text-midnight" : "text-white"}`}>
                  <div className="hidden lg:block">
                    <a href="#our-journey" className="hover:underline ease-in-out duration-300">Our Journey</a>
                  </div>
                  <div className="hidden lg:block">
                    <a href="#what-we-do" className="hover:underline ease-in-out duration-300">What we do</a>
                  </div>
                  <div className="hidden lg:block">
                    <a href="#we-supercharge-brands" className="hover:underline ease-in-out duration-300">Supercharging brands</a>
                  </div>
                  <div className="hidden lg:block">
                    <a href="#awards" className="hover:underline ease-in-out duration-300">Awards</a>
                  </div>
                  <div className="hidden lg:block">
                    <a href="#our-team" className="hover:underline ease-in-out duration-300">Our team</a>
                  </div>
                  <div className="">
                    <a href="#contact-us" className="hover:underline ease-in-out duration-300">Contact us</a>
                  </div>
                  </div>
                </div> 
              </nav>
            </header>
      </div>
    </SbEditable>
  )
}

export default Navigation;
